import PageHeader from "src/components/PageHeader";

export default function Brands() {
  return (
    <PageHeader
      title="مدیریت برندها"
    />
  )
}